import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Drawer, Stack, Typography } from '@mui/material';
import React from 'react';
import CircledCrossIcon from '../../../constants/icons/CircledCrossIcon';
import styled from '@emotion/styled';
import { HELP_ICON } from '../../../constants/icons/HelpIcon';
import { COLOR_MAP } from '../../../constants/ColorNames';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type HelpDrawerProps = {
  showModal: boolean,
  closeModal: () => void,
  data: any
}

const StyledCircleIcon = styled(CircledCrossIcon)`
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 60.3rem;
  cursor: pointer;
`;

const Container = styled.div`
  max-width: 550px;
  margin-top: 55px;
`
const HelpText = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
  margin-top: 2px;
  color: ${COLOR_MAP.BLACK};
`;

const Title = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin: 0;
  color: ${COLOR_MAP.LIGHT_GREY}
`;

const Content = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin: 0;
  color: ${COLOR_MAP.GREY_2}
`

const Points = styled.span`
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  padding: 1px 5px;
  border-radius: 4px;
  color: white;
  background-color: #6E00BE;
  font-size: 12px;
  height: fit-content;
  margin-right: 4px;
  margin-top: 2px;
  height: 15px;
  display: flex;
  align-items: center;
  font-weight: 700;
`

const HelpDrawer = (props: HelpDrawerProps) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const { showModal, closeModal, data } = props;

  const handleChange =
  (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Drawer anchor="right" open={showModal} onClose={closeModal}>
      <StyledCircleIcon onClick={closeModal} />
      <Container>
        <Stack direction={'row'} gap={'8px'} padding={'16px'}>
          {HELP_ICON}
          <HelpText>Help</HelpText>
        </Stack>
        <Divider
          style={{
            height: '0.1rem',
            backgroundColor: COLOR_MAP.DISABLED
          }}
          orientation="vertical"
          flexItem
        />
        {data && data.length ?
          data.map((item: any, index: number) => {
            return (
              <Box sx={{ padding: '16px 16px 0 16px' }}>
                <Accordion sx={{
                    boxShadow: 'none',
                    '& .MuiButtonBase-root': {
                      paddingLeft: 0
                    }
                }} key={index}
                expanded={expanded === `panel${index+1}`} onChange={handleChange(`panel${index+1}`)}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon fontSize='large'/>} aria-controls="panel1d-content" id="panel1d-header">
                    <Title>{item.title}</Title>
                  </AccordionSummary>
                  <AccordionDetails sx={{
                    paddingTop: '0px !important'
                  }}>
                   <Content>
                      {item.body.includes("\n") ? (
                         <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                         {item.body.split("\n").map((line: string, index: number) => (
                           <li key={`option_${index}`} style={{display:"flex"}}>
                             <Points>{index+1}</Points> <span>{line}</span>
                           </li>
                         ))}
                       </ul>
                      ) : (
                        <p>{item.body}</p>
                      )}
                  </Content>

                  </AccordionDetails>
                </Accordion>
                <Divider
                  style={{
                    height: '0.1rem',
                    backgroundColor: COLOR_MAP.DISABLED
                  }}
                  orientation="vertical"
                  flexItem
                />
              </Box>
            )
          })
          : null
        }
      </Container>
    </Drawer>
  )
}

export default HelpDrawer;
